import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UIButton } from '../button';
import { UIIcon } from '../icon';
import { UIForm } from '../form/form.component';
import { FormGroup } from '@angular/forms';
import { IFormGroupConfig } from '../form';
import { LocalizationPipe } from '@shared/modules/localization';

@Component({
  selector: 'ui-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  standalone: true,
  imports: [UIButton, UIIcon, UIForm, LocalizationPipe],
})
export class UIFilter {
  @Input({ required: true }) form?: FormGroup;
  @Input({ required: true }) formConfig?: IFormGroupConfig;

  @Output() filterClosed = new EventEmitter<void>();
  @Output() filterApplied = new EventEmitter<NonNullable<any>>();

  get canApply(): boolean {
    return this.form?.valid as boolean;
  }

  resetFilter(): void {
    this.form?.reset();
    this.applyFilter();
  }

  applyFilter(): void {
    this.filterApplied.emit(this.form?.value);
  }

  onFilterClosed(): void {
    this.filterClosed.emit();
  }
}
